import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

// Removed individual caching logic, now handled by axiosConfig interceptors

const fetchSeoSettings = async (pageKey) => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.SEO_SETTINGS(pageKey)); // Use apiClient.get
    if (response.data.success && response.data.data) { // Axios wraps response in .data
      return response.data.data; // Return the actual SEO data object
    }
    return null; // Return null if no data or not successful
  } catch (error) {
    console.error(`Error fetching SEO settings for ${pageKey}:`, error);
    throw error;
  }
};

export { fetchSeoSettings };